import { useCallback, useEffect, useState } from "react";

export function usePlainChat() {
    const [isOpen, setIsOpen] = useState(false);

    useEffect(() => {
        window?.Plain?.onOpen(() => setIsOpen(true));
        window?.Plain?.onClose(() => setIsOpen(false));
    }, []);

    const openChat = useCallback(() => {
        window?.Plain?.open();
    }, []);

    const closeChat = useCallback(() => {
        window?.Plain?.close();
    }, []);

    return {
        openChat,
        closeChat,
        isOpen,
    };
}
